export const navBarSelector = ({navBarState}) => navBarState